import * as React from "react";
import DateRange from "./components/DateRange";

export default function Toolbar() {
  return <DateRange />;
}
